import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../../../Components/OneModal/OneModal'

const ModalFoto = ({ open, setOpen, imageName, eventId }) => {
    const src = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/dados/eventos/${eventId}/${imageName}`

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={imageName}
        >
            <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <img style={{ maxWidth: '100%', maxHeight: '100%', height: 'auto', width: 'auto' }} src={src} />
            </Grid>
        </OneModal>
    )
}

export default ModalFoto
